import { Button, ButtonProps, useBreakpointValue } from '@chakra-ui/react'
import React from 'react'

type TimeSlotButtonProps = {
  onClick?: () => void
  isActive?: boolean
  isAvailable: boolean
} & ButtonProps

const TimeSlotButton: React.FC<TimeSlotButtonProps> = (props) => {
  const isMobile = useBreakpointValue({ base: true, md: false })
  const { onClick, isActive = false, isAvailable, ...rest } = props

  // 予約不可
  if (!isAvailable) {
    return (
      <Button
        w="100%"
        h={{ base: '56px', md: '64px' }}
        borderRadius="8px"
        backgroundColor="gray.100"
        pointerEvents="none"
        display="flex"
        justifyContent="center"
        alignItems="center"
        _hover={{ bg: "gray.100" }}
        {...rest}
      >
        <span style={{ color: '#C84545', fontSize: isMobile ? '20px' : '24px', fontWeight: 'bold' }}>
          ✕
        </span>
      </Button>
    )
  }

  // 選択可能
  return (
    <Button
      w="100%"
      h={{ base: '56px', md: '64px' }}
      borderRadius="8px"
      borderWidth="2px"
      borderColor="#6AA43B"
      backgroundColor={isActive ? '#6AA43B' : 'white'}
      onClick={onClick}
      display="flex"
      justifyContent="center"
      alignItems="center"
      _hover={isActive ? { bg: '#6AA43B' } : { bg: 'green.50' }}
      {...rest}
    >
      <span style={{ 
        color: isActive ? 'white' : '#6AA43B', 
        fontSize: isMobile ? '20px' : '24px', 
        fontWeight: 'bold' 
      }}>
        ○
      </span>
    </Button>
  )
}

export default TimeSlotButton 